import { Pipe, PipeTransform } from '@angular/core';
import { Frequency as GalaxyFrequency } from '@vendasta/galaxy/frequency';
import { RevenuePeriod } from '@vendasta/sales-orders';

@Pipe({ name: 'revenuePeriodToGalaxyFrequency', standalone: true })
export class RevenuePeriodToGalaxyFrequency implements PipeTransform {
  transform(value: RevenuePeriod): GalaxyFrequency {
    return revenuePeriodToGalaxyFrequency(value);
  }
}

export function revenuePeriodToGalaxyFrequency(value: RevenuePeriod): GalaxyFrequency {
  switch (value) {
    case RevenuePeriod.ONETIME:
      return GalaxyFrequency.ONE_TIME;
    case RevenuePeriod.YEARLY:
      return GalaxyFrequency.YEARLY;
    default:
      return GalaxyFrequency.MONTHLY;
  }
}

@Pipe({ name: 'galaxyFrequencyToRevenuePeriod', standalone: true })
export class GalaxyFrequencyToRevenuePeriodPipe implements PipeTransform {
  transform(value: GalaxyFrequency): RevenuePeriod {
    return galaxyFrequencyToRevenuePeriod(value);
  }
}

export function galaxyFrequencyToRevenuePeriod(value: GalaxyFrequency): RevenuePeriod {
  switch (value) {
    case GalaxyFrequency.ONE_TIME:
      return RevenuePeriod.ONETIME;
    case GalaxyFrequency.YEARLY:
      return RevenuePeriod.YEARLY;
    default:
      return RevenuePeriod.MONTHLY;
  }
}
